// A new upload is stored as 32 lowercase hex characters, an underscore, then the original name.
export function documentDisplayName(storedFile: string): string {
  const storedName = storedFile.substring(storedFile.lastIndexOf('/') + 1);
  return storedName.replace(/^[0-9a-f]{32}_/, '');
}
